import React, { Component } from 'react';
import classNames from 'classnames';

import Banner from "./Banner";

class TimedBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: this.props.open,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!!nextProps.open && this.props.open !== nextProps.open) this.show();
  }

  startCountdown = () => {
    const duration = this.props.duration * 1000;
    setTimeout(() => this.setState({open: false}), duration);
  }

  show = () => {
    const { duration } = this.props;
    this.setState({open: true}, () => {
      if (duration !== -1) {
        this.startCountdown()
      }
    });
  }

  close = (e) => {
    e.preventDefault()
    this.resetNotice()
  }

  resetNotice = () => this.setState({open: false})

  classNames() {
    return classNames(
      this.props.className,
      { '_displayBlock': this.state.open },
      { '_displayNone': !this.state.open },
    );
  }

  render() {
    const {header, body} = this.props;
    return (
      <Banner
        className={this.classNames()}
        header={header}
        body={body}
        onClose={ (this.props.duration === -1) ? null : this.close}
      /> 
    )
  }
}

TimedBanner.defaultProps = {
  open: false,
  className: '-primary',
  duration: 3,
  header: '',
  body: '',
};

export default TimedBanner;



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/TimedBanner.js